// extracted by mini-css-extract-plugin
module.exports = {"cookieContainer":"style-module--cookieContainer--LoBCl","cookieButton":"style-module--cookieButton--2Xhnr","cookieContent":"style-module--cookieContent--1Et6P"};